import { storage, isBrowser } from '../lib/storage'
import { AdminApiClient } from './AdminApiClient'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api'

// Sprint H Phase 3 (rev3 fix #11): the apiClient singleton is now an
// AdminApiClient instance. All admin code paths (services/domains/*, hooks,
// components) import from here, so this swap propagates without touching
// callers — they keep using `apiClient.get(...)` / `apiClient.requestRaw(...)`
// / `apiClient.admin.*` exactly as before.
export const apiClient = new AdminApiClient(API_BASE_URL)

/**
 * Sprint B (Master Plan v5.1): all localStorage access goes through StorageSlot.
 * StorageSlot returns null until window.__TENANT_SLUG__ is set; AuthContext
 * blocks API calls until tenant resolves, so the brief null-token window is
 * harmless. Module-init read here is a best-effort early bind — if tenant
 * isn't ready, apiClient.token stays null and AuthContext re-binds on tenant
 * resolve.
 */
if (isBrowser) {
  const savedToken = storage.authToken.get()
  if (savedToken) {
    apiClient.setToken(savedToken)
  }
}

export const setAuthToken = (token: string) => {
  if (isBrowser) {
    // storage.authToken.set throws without slug — that's intended (rule #2).
    // Login flow runs strictly after TenantProvider resolves, so this always
    // has slug at call time.
    storage.authToken.set(token)
  }
  apiClient.setToken(token)
}

export const clearAuthToken = () => {
  if (isBrowser) {
    storage.authToken.remove()
  }
  apiClient.setToken(null)
}

export const getStoredToken = (): string | null => {
  return isBrowser ? storage.authToken.get() : null
}

// Setup 401 handler - redirect to login and clear auth state
if (isBrowser) {
  apiClient.setUnauthorizedHandler(() => {
    console.warn('[Auth] 401 Unauthorized - clearing session and redirecting to login')
    clearAuthToken()

    import('./socketService').then(({ adminSocketService }) => {
      adminSocketService.disconnect()
    })

    window.location.href = '/login'
  })
}
